import { useEffect, useRef, useState } from "react";
import { CheckSquare, Search } from "react-feather";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import {
  addDeductionApprovalDetails,
  deductionApprovalById,
  searchDeductApproval,
  updateDeductionApprovalDetails,
} from "../../api/ApprovalMasterApi";
import { getBulkDropdownData } from "../../api/keyvalue";
import Grid from "../../components/Grid";
import LoadingSpinner from "../../components/LoadingSpinner";
import Button from "../../components/input/Button";
import Dropdown from "../../components/input/Dropdown";
import Input from "../../components/input/Input";
import SideDrawer from "../../components/input/SideDrawer";
import ApprovalMasterDetailsForm from "../../components/master/deduction/ApprovalMasterDetailsForm";
import ApprovalMasterHeaderForm from "../../components/master/deduction/ApprovalMasterHeaderForm";
import {
  ActiveCellStyle,
  ResizableScrollingTextRenderer,
  StatusCellStyle,
} from "../../components/renderer/StyleRenderer";
import { approveHeaderValidation } from "../../components/validations/DeductionCreation";
import useUserCompany from "../../hooks/useUserCompany";
import { errorActions } from "../../store/error-slice";

const ApprovalMaster = () => {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user);
  const [editApproval, setEditApproval] = useState({});

  const userCompany = useUserCompany();

  const [company, setCompany] = useState(
    userCompany ? userCompany.comId : null
  );

  useEffect(() => {
    setCompany(userCompany ? userCompany.comId : null);
  }, [userCompany]);

  //drawer
  const [tab, setTab] = useState(1);
  const [drawerTab, setDrawerTab] = useState(1);

  //flags
  const [activeAccordion1, setActiveAccordion1] = useState(true);
  const [resetVisible, setResetVisible] = useState(false);
  const [searchClicked, setSearchClicked] = useState(false);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isSubmitLoading, setIsSubmitLoading] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [searchFetchLoading, setSearchFetchLoading] = useState(false);
  const [isSearchLoading, setIsSearchLoading] = useState(false);
  const [searchSubmitLoading, setSearchSubmitLoading] = useState(false);
  const [searchRes, setSearchRes] = useState(false);
  const [isAppTypeExists, setIsAppTypeExists] = useState(false);

  //errors
  const errorState = useSelector(
    (state) => state.error.deductApprovalHeaderErrors
  );

  // tab ref
  const approvalHeaderRef = useRef();
  const approvalDetailRef = useRef();

  //search ref
  const codeRef = useRef(null);
  const nameRef = useRef(null);
  const levelRef = useRef(null);

  //search status
  const [status, setStatus] = useState(null);
  const [active, setActive] = useState(null);
  const [approvalType, setApprovalType] = useState(null);

  //dropdown
  const [approvalTypeOptions, setApprovalTypeOptions] = useState([]);
  const [activeOptions, setActiveOptions] = useState([]);
  const [statusOptions, setStatusOptions] = useState([]);

  const [approvalTypes, setApprovalTypes] = useState(null);

  const [headerAudit, setHeaderAudit] = useState(null);

  useEffect(() => {
    (async () => {
      //new

      const {
        active,
        status,
        approval_types: approvalTypesOpt,
      } = await getBulkDropdownData([
        { key: "active" },
        { key: "status" },
        { key: "approval_types" },
      ]);

      setApprovalTypeOptions(approvalTypesOpt);
      setStatusOptions(status);
      setActiveOptions(active);
    })();
  }, []);

  const handleDrawerOpen = () => {
    dispatch(errorActions.clearDeductApprovalHeaderError());
    dispatch(errorActions.clearDeductApprovalDetailError());
    setIsDrawerOpen(true);
    setEditMode(false);
    setEditApproval(null);
    setDrawerTab(1);
  };

  const handleDrawerClose = () => {
    setIsDrawerOpen(false);
    dispatch(errorActions.clearDeductApprovalDetailError());
    dispatch(errorActions.clearDeductApprovalHeaderError());
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitLoading(true);

    dispatch(errorActions.clearDeductApprovalHeaderError());
    dispatch(errorActions.clearDeductApprovalDetailError());
    const deductAppErrors = approveHeaderValidation(
      approvalHeaderRef.current.getData()
    );
    if (Object.keys(deductAppErrors).length > 0) {
      dispatch(
        errorActions.validateDeductApprovalHeaderCreation({
          deductAppData: approvalHeaderRef.current.getData(),
        })
      );
      setIsSubmitLoading(false);
      toast.error("There was an error adding Approval", {
        autoClose: 5000,
        containerId: "Main",
      });
      return;
    } else {
      if (editMode) {
        const approvalDetails = approvalDetailRef.current.getData();
        if (approvalDetails.length <= 0) {
          dispatch(
            errorActions.addDeductApprovalHeaderErrorObject({
              form: "submitErrors",
              key: "approvalDetailsError",
              value: "Should have at least one approval detail",
            })
          );
          toast.error("Should have at least one approval detail", {
            autoClose: 5000,
            containerId: "Main",
          });
          setIsSubmitLoading(false);
          return;
        }
        try {
          const response = await updateDeductionApprovalDetails({
            approvalDetailUpdateContainer: approvalDetailRef.current.getData(),
            approvalHeaderRequest: approvalHeaderRef.current.getData(),
            author: user.username,
          });
          if (response?.data === "success") {
            toast.success("Approval Details updated successfully!", {
              autoClose: 5000,
              containerId: "Main",
            });
            // reset();
          } else if (response?.data === "approval_exists") {
            toast.error(
              "The current approver already has approval requests awaiting action!",
              {
                autoClose: 5000,
                containerId: "Main",
              }
            );
          }
          setIsSubmitLoading(false);
        } catch (e) {
          setIsSubmitLoading(false);
        }
        reset();
      } else {
        const approvalDetails = approvalDetailRef.current.getData();
        if (approvalDetails.length <= 0) {
          dispatch(
            errorActions.addDeductApprovalHeaderErrorObject({
              form: "submitErrors",
              key: "approvalDetailsError",
              value: "Should have at least one approval detail",
            })
          );
          toast.error("Should have at least one approval detail", {
            autoClose: 5000,
            containerId: "Main",
          });
          setIsSubmitLoading(false);
          return;
        }
        try {
          const response = await addDeductionApprovalDetails({
            approvalDetailsRequests: approvalDetailRef.current.getData(),
            approvalHeaderRequest: approvalHeaderRef.current.getData(),
            author: user.username,
          });
          if (response !== null) {
            toast.success("Approval Details added successfully!", {
              autoClose: 5000,
              containerId: "Main",
            });
            // reset();
          }
          setIsSubmitLoading(false);
        } catch (error) {
          setIsSubmitLoading(false);
        }
        reset();
      }
    }
    setIsSubmitLoading(false);
  };
  const reset = () => {
    approvalHeaderRef.current.resetForm();
    approvalDetailRef.current.resetForm();
    setEditMode(false);
    setEditApproval(null);
  };

  const handleSearchSubmit = async (e) => {
    e.preventDefault();
    dispatch(errorActions.clearDeductApprovalHeaderError());
    dispatch(errorActions.clearDeductApprovalDetailError());
    setActiveAccordion1(false);
    setResetVisible(true);
    setSearchClicked(true);
    setSearchSubmitLoading(true);
    const response = await searchDeductApproval({
      appCode: codeRef.current.value,
      appName: nameRef.current.value,
      appCompany: company,
      appApprovals: approvalType,
      appLevels: levelRef.current.value,
      appStatus: status,
      appActive: active,
    });
    setSearchRes(response);
    setSearchSubmitLoading(false);
  };
  const handleSearchReset = (e) => {
    e.preventDefault();
    setStatus(null);
    setActive(null);
    setApprovalType(null);
    codeRef.current.reset();
    nameRef.current.reset();
    levelRef.current.reset();
  };

  return (
    <>
      <div
        className="ui attached tabular"
        style={{
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <div className="ui tabular menu attached">
          <div
            className={`item ${tab === 1 ? "active" : ""}`}
            onClick={() => {
              setTab(1);
            }}
          >
            <span>
              <CheckSquare size={15} style={{ marginRight: "5px" }} />
            </span>
            Deduction Approval Search
          </div>
        </div>
        <div
          className="ui primary button"
          style={{
            display: "flex",
            alignItems: "right",
            cursor: "pointer",
            height: "40px",
          }}
          onClick={handleDrawerOpen}
        >
          <i className="plus icon"></i>
          <span>Add</span>
        </div>
      </div>
      <div
        className="ui bottom attached active tab segment"
        style={{ display: tab === 1 ? "block" : "none" }}
      >
        <div className="ui styled accordion" style={{ width: "100%" }}>
          <div
            className={`title ${activeAccordion1 ? "active" : ""}`}
            onClick={() => setActiveAccordion1(!activeAccordion1)}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <div>
                <span>Search</span>
                <Search size={14} style={{ marginLeft: "10px" }} />
                <i className="dropdown icon"></i>
              </div>

              <i
                className="refresh icon primary button"
                style={{
                  display: `${resetVisible ? "flex" : "none"}`,
                  cursor: "pointer",
                }}
                onClick={(e) => {
                  // handleReset(e);
                }}
              ></i>
            </div>
          </div>
          <div className={`content ${activeAccordion1 ? "active" : ""}`}>
            {isSearchLoading ? (
              <LoadingSpinner />
            ) : (
              <form className="ui form">
                <div className="four fields">
                  <Input
                    label="Approval Code"
                    placeholder="Item Code"
                    name="itemCode"
                    ref={codeRef}
                  />
                  <Input
                    label="Approval Name"
                    placeholder="Item Name"
                    name="itemName"
                    ref={nameRef}
                  />
                  <Dropdown
                    label="Approval Type"
                    options={approvalTypeOptions}
                    placeholder="Item Type"
                    style={{ height: "20px" }}
                    value={approvalType}
                    onChange={(e, data) => {
                      setApprovalType(data.value);
                    }}
                  />
                  <Input
                    label="Approval Levels"
                    placeholder="Approval Levels"
                    name="ItemCharge"
                    type="number"
                    min={0}
                    ref={levelRef}
                  />
                </div>

                <div className="four fields">
                  <Dropdown
                    label="Status"
                    options={statusOptions}
                    placeholder="Status"
                    style={{ height: "20px" }}
                    value={status}
                    onChange={(e, data) => {
                      setStatus(data.value);
                    }}
                  />
                  <Dropdown
                    label="Active"
                    options={activeOptions}
                    placeholder="Active"
                    style={{ height: "20px" }}
                    value={active}
                    onChange={(e, data) => {
                      setActive(data.value);
                    }}
                  />
                </div>
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-end",
                  }}
                >
                  <div className="field" style={{ width: "100%" }}>
                    <Button
                      template="search"
                      onClick={(e) => {
                        handleSearchSubmit(e);
                      }}
                    />
                    <Button
                      template="searchReset"
                      onClick={(e) => {
                        handleSearchReset(e);
                      }}
                    />
                  </div>
                </div>
              </form>
            )}
          </div>
        </div>
        {searchClicked && (
          <>
            {searchSubmitLoading ? (
              <LoadingSpinner />
            ) : (
              <Grid
                isLoading={searchFetchLoading}
                content={searchRes}
                config={[
                  {
                    headerName: "Id",
                    field: "appId",
                    sort: "desc",
                    hide: true,
                  },
                  {
                    headerName: "Code",
                    field: "appCode",
                  },
                  {
                    headerName: "Name",
                    field: "appName",
                    cellRenderer: ResizableScrollingTextRenderer,
                  },
                  {
                    headerName: "Type",
                    field: "appApprovals",
                    cellRenderer: ResizableScrollingTextRenderer,
                  },
                  {
                    headerName: "Status",
                    field: "status",
                    cellRenderer: StatusCellStyle,
                  },
                  {
                    headerName: "Active",
                    field: "active",
                    cellRenderer: ActiveCellStyle,
                  },
                ]}
                onCellDoubleClicked={async (props) => {
                  setSearchFetchLoading(true);
                  const response = await deductionApprovalById(
                    props.data.appId
                  );
                  setEditApproval(response);
                  setEditMode(true);
                  setIsDrawerOpen(true);
                  setSearchFetchLoading(false);
                }}
              />
            )}
          </>
        )}
      </div>
      <SideDrawer
        open={isDrawerOpen}
        handleDrawerClose={handleDrawerClose}
        head={
          editMode ? (
            <>
              <div
                className="cluster-code-header"
                style={{ padding: "10px 16px", borderBottom: "1px solid #ccc" }}
              >
                <h3>
                  Deduction Approval Code:{" "}
                  {editApproval?.approvalHeaderResponse?.appCode}
                </h3>
              </div>
            </>
          ) : null
        }
        body={
          <form className="drawer-content" onSubmit={handleSubmit}>
            <div style={{ width: "60vw", boxShadow: "none" }}>
              <div className="ui top attached tabular menu">
                <div
                  className={`item ${drawerTab === 1 ? "active" : ""}`}
                  onClick={() => {
                    setDrawerTab(1);
                  }}
                >
                  <span>
                    <CheckSquare
                      size={15}
                      style={{
                        marginRight: "5px",
                        color: `${
                          Object.keys(errorState.deductApprovalHeaderErrors)
                            .length !== 0
                            ? "#e0b4b4"
                            : ""
                        }`,
                      }}
                    />
                  </span>
                  <label
                    style={{
                      color: `${
                        Object.keys(errorState.deductApprovalHeaderErrors)
                          .length !== 0
                          ? "#e0b4b4"
                          : ""
                      }`,
                    }}
                  >
                    Approval
                  </label>
                </div>
              </div>
              <div
                className="ui bottom attached active tab segment"
                style={{ display: drawerTab === 1 ? "block" : "none" }}
              >
                <ApprovalMasterHeaderForm
                  ref={approvalHeaderRef}
                  editMode={editMode}
                  currentValues={
                    editMode ? editApproval.approvalHeaderResponse : null
                  }
                  isLoading={isLoading}
                  setIsAppTypeExists={setIsAppTypeExists}
                  setApprovalTypes={setApprovalTypes}
                  errors={errorState.deductApprovalHeaderErrors}
                  setHeaderAudit={setHeaderAudit}
                />
                <br />
                <ApprovalMasterDetailsForm
                  ref={approvalDetailRef}
                  editMode={editMode}
                  currentValues={
                    editMode ? editApproval.approvalDetailsResponse : null
                  }
                  currentHeaderValue={
                    editMode ? editApproval.approvalHeaderResponse : null
                  }
                  isLoading={isLoading}
                  approvalTypes={approvalTypes}
                  headerAudit={headerAudit}
                />
              </div>
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "flex-end",
                }}
              >
                <div style={{ display: "flex", alignItems: "center" }}>
                  {drawerTab === 1 && !isLoading ? (
                    <Button
                      type="submit"
                      disabled={isAppTypeExists}
                      template="create"
                      isLoading={isSubmitLoading}
                      create={!editMode}
                    />
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </div>
          </form>
        }
        style={{ width: "60vw", boxShadow: "none" }}
      />
    </>
  );
};
export default ApprovalMaster;
